import { render, staticRenderFns } from "./create-registration-index.vue?vue&type=template&id=2fa58898&scoped=true"
import script from "@/components/registrations/create-registration/index/create-registration-index?vue&type=script&lang=js&external"
export * from "@/components/registrations/create-registration/index/create-registration-index?vue&type=script&lang=js&external"
import style0 from "./create-registration-index.vue?vue&type=style&index=0&id=2fa58898&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa58898",
  null
  
)

export default component.exports